import React, { useEffect, useState } from 'react';
import Image from '../../../Image';

interface Props {
	className?: string;
	source: string;
	data: any;
	onPreview?: () => void;
}

const ChatMessageImage: React.FC<Props> = ({
	className,
	source,
	data,
	onPreview,
}) => {
	const [isAvailable, setIsAvailable] = useState(true);
	const [attempt, setAttempt] = useState(0);
	const retryDelays = [2000, 4000, 8000, 16000, 30000];
	useEffect(() => {
		setIsAvailable(true);
		setAttempt(0);
	}, [source]);
	useEffect(() => {
		if (isAvailable || attempt >= retryDelays.length) return;
		const timer = window.setTimeout(() => {
			setAttempt(value => value + 1);
			setIsAvailable(true);
		}, retryDelays[attempt]);
		return () => window.clearTimeout(timer);
	}, [isAvailable, attempt, source]);

	const onError = () => {
		setIsAvailable(false);
	};

	if (!isAvailable) {
		return (
			<div role="status" style={{ padding: '12px 16px', color: '#52766d' }}>
				{attempt < retryDelays.length ? 'Cargando imagen…' : <>
					<span>No se ha podido cargar la imagen. </span>
					<button type="button" onClick={() => {setAttempt(0); setIsAvailable(true);}}
						style={{background: 'none', border: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>Reintentar</button>
				</>}
			</div>
		);
	}

	return (
		<Image
			key={`${source}:${attempt}`}
			className={'chat__media' + (className ? ' ' + className : '')}
			src={source}
			alt={data.caption}
			onClick={onPreview}
			onError={onError}
		/>
	);
};

export default ChatMessageImage;
